import listActions from 'src/modules/tipoServicio/list/tipoServicioListActions';
import TipoServicioService from 'src/modules/tipoServicio/tipoServicioService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'TIPOSERVICIO_DESTROY';

const tipoServicioDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: tipoServicioDestroyActions.DESTROY_STARTED,
      });

      await TipoServicioService.destroyAll([id]);

      dispatch({
        type: tipoServicioDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.tipoServicio.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/tipo-servicio');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: tipoServicioDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: tipoServicioDestroyActions.DESTROY_ALL_STARTED,
      });

      await TipoServicioService.destroyAll(ids);

      dispatch({
        type: tipoServicioDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.tipoServicio.destroyAll.success'),
      );

      getHistory().push('/tipo-servicio');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: tipoServicioDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default tipoServicioDestroyActions;
